import { render, staticRenderFns } from "./ImageInner.vue?vue&type=template&id=37b8187e&"
import script from "./ImageInner.vue?vue&type=script&lang=js&"
export * from "./ImageInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports